<template>
    <section class="package-type">
        <v-tabs v-model="tab" :change="changeTab(tab)"
                next-icon="mdi-arrow-right-bold-box-outline"
                prev-icon="mdi-arrow-left-bold-box-outline"
                show-arrows>
            <v-tabs-slider></v-tabs-slider>
            <v-tab v-for="item in items">
                    <span class="package-type__tab">
                           {{ item.tabLabel }}
                    </span>

            </v-tab>
        </v-tabs>

        <v-tabs-items v-model="tab">
            <v-tab-item v-for="item in items">
                <v-card flat>
                    <div class="package-type__content">
                        <div class="position-relative">
                            <img class="package-type__img" :src=item.tabImg alt="">
                            <v-tabs
                                    v-model="point"
                                    :change="changeTab(point)"
                            >
                                <v-tab class="package-type__dots"
                                       v-for="(dot, idx) of item.tabDots"
                                       :key="idx"
                                       :style="{ left: `${dot.tabDotX}%`, top: `${dot.tabDotY}%` }"
                                       :class="item.tabDots.length > 1 ? '':'d-none'"
                                >
                                    <div class="package-type__dot">
                                    </div>
                                </v-tab>
                            </v-tabs>
                        </div>

                        <v-tabs-items v-model="point">
                            <v-tab-item v-for="info in item.tabDots">
                                <v-card flat>
                                    <v-card>
                                        <div class="package-type__info">
                                            <div v-for="(text, index) of  info.tabContentInfo"
                                                 :key="index" v-html="text.tabContentDescr">
                                            </div>
                                            <a href="javascript:void(0)" onclick="scrollOnBlock(formNew)"
                                               class="package-type__btn btn-red">
                                                Оставить заявку для подбора решения
                                            </a>
                                        </div>
                                    </v-card>
                                </v-card>
                            </v-tab-item>
                        </v-tabs-items>
                    </div>
                </v-card>
            </v-tab-item>
        </v-tabs-items>
    </section>
</template>

<script>

export default {
    name: "packageType",
    props: {
        types: String | Array | Object,
    },
    data() {
        return {
            tab: null,
            point: null,
            /*items: [
                {
                    tabLabel: "Картридж",
                    tabImg: '/upload/package.jpg',
                    tabDots: [
                        {
                            tabDotX: "35",
                            tabDotY: "30",
                            tabContentInfo: [
                                {
                                    tabContentSubtitle: "Продукт Картридж",
                                    tabContentDescr: "прозрачная клейкая упаковочная лента NOVAROL",
                                },
                                {
                                    tabContentSubtitle: "Назначение2 Картридж",
                                    tabContentDescr: "склеивание стенок гофрокороба для дальнейшей транспортировкиы",
                                },
                                {
                                    tabContentSubtitle: "Назначение3 Картридж",
                                    tabContentDescr: "склеивание стенок гофрокороба для дальнейшей транспортировкиы",
                                },
                            ],
                        },
                        {
                            tabDotX: "10",
                            tabDotY: "50",
                            tabContentInfo: [
                                {
                                    tabContentSubtitle: "Продукт Картридж",
                                    tabContentDescr: "прозрачная клейкая упаковочная лента NOVAROL",
                                },
                                {
                                    tabContentSubtitle: "Назначение2 Картридж",
                                    tabContentDescr: "склеивание стенок гофрокороба для дальнейшей транспортировкиы",
                                },

                            ],
                        },
                        {
                            tabDotX: "65",
                            tabDotY: "27",
                            tabContentInfo: [
                                {
                                    tabContentSubtitle: "Продукт Картридж",
                                    tabContentDescr: "прозрачная клейкая упаковочная лента NOVAROL",
                                },
                            ],
                        },
                    ],
                    tabContentUrl: "#"
                },
                {
                    tabLabel: "Ведро",
                    tabImg: '/upload/package.jpg',
                    tabDots: [
                        {
                            tabDotX: "-20",
                            tabDotY: "30",

                            tabContentInfo: [
                                {
                                    tabContentSubtitle: "Продукт Ведро",
                                    tabContentDescr: "прозрачная клейкая упаковочная лента NOVAROL",
                                },
                                {
                                    tabContentSubtitle: "Назначение3 Ведро",
                                    tabContentDescr: "склеивание стенок гофрокороба для дальнейшей транспортировкиы",
                                },
                            ],
                        },
                        {
                            tabDotX: "0",
                            tabDotY: "15",
                            tabContentInfo: [
                                {
                                    tabContentSubtitle: "Продукт Ведро",
                                    tabContentDescr: "прозрачная клейкая упаковочная лента NOVAROL",
                                },

                            ],
                        },
                        {
                            tabDotX: "60",
                            tabDotY: "40",
                            tabContentInfo: [
                                {
                                    tabContentSubtitle: "Продукт",
                                    tabContentDescr: "прозрачная клейкая упаковочная лента NOVAROL",
                                },
                            ],
                        },
                    ],
                    tabContentUrl: "#"
                },
                {
                    tabLabel: "Туба",
                    tabImg: '/upload/package.jpg',
                    tabDots: [
                        {
                            tabDotX: "75",
                            tabDotY: "10",
                            tabContentInfo: [
                                {
                                    tabContentSubtitle: "Продукт",
                                    tabContentDescr: "прозрачная клейкая упаковочная лента NOVAROL",
                                },
                                {
                                    tabContentSubtitle: "Назначение2",
                                    tabContentDescr: "склеивание стенок гофрокороба для дальнейшей транспортировкиы",
                                },
                                {
                                    tabContentSubtitle: "Назначение3",
                                    tabContentDescr: "склеивание стенок гофрокороба для дальнейшей транспортировкиы",
                                },
                            ],
                        },
                        {
                            tabDotX: "80",
                            tabDotY: "77",
                            tabContentInfo: [
                                {
                                    tabContentSubtitle: "Продукт",
                                    tabContentDescr: "прозрачная клейкая упаковочная лента NOVAROL",
                                },
                                {
                                    tabContentSubtitle: "Назначение2",
                                    tabContentDescr: "склеивание стенок гофрокороба для дальнейшей транспортировкиы",
                                },

                            ],
                        },
                        {
                            tabDotX: "16",
                            tabDotY: "30",
                            tabContentInfo: [
                                {
                                    tabContentSubtitle: "Продукт",
                                    tabContentDescr: "прозрачная клейкая упаковочная лента NOVAROL",
                                },
                            ],
                        },
                    ],
                    tabContentUrl: "#"
                },

            ]*/
            items: this.types,
        }
    },
    methods: {
        changeTab(item) {

        },
    }
}
</script>

<style lang="scss">
.package-type {
  margin-bottom: 80px;

  .v-tab:not(.v-tab--active) {
    & svg {
      display: none;
    }
  }

  & .v-tabs-slider {
    height: 0;
  }

  .v-tabs:not(.v-tabs--vertical):not(.v-tabs--right) > .v-slide-group--is-overflowing.v-tabs-bar--is-mobile:not(.v-slide-group--has-affixes) .v-slide-group__prev {
    display: none;
  }

  .v-tabs {
    @media (max-width: 766px) {
      max-width: 90vw;
    }
  }

  & .theme--light.v-tabs > .v-tabs-bar {
    margin-bottom: 40px;
  }

  & .v-tab {
    gap: 14px;
    margin: 5px;
    border: 1.4px solid #E8E8E8;
    background: #FFFFFF;
    border-radius: 40px;
    padding: 16px 20px;
    height: 52px;

    &:hover {
      opacity: 1 !important;
      border: 1px solid #4F4D55;
    }

    @media (max-width: 1024px) {
      padding: 5px 60px;
    }

    @media (max-width: 1024px) {
      padding: 5px 20px;
    }

    &:before {
      background-color: transparent !important;
    }

    & > span {
      font-family: 'Inter', sans-serif;
      font-size: 16px;
      font-weight: 500;
      line-height: 28px;
      letter-spacing: 0;
      color: #252525 !important;
      text-transform: none;
    }

    &--active {
      border: 1px solid #F94337;
      border-radius: 40px;
      mask-image: radial-gradient(white, black);
      will-change: transform;

      &:hover {
        opacity: 1 !important;
        border: 1px solid #FA4237;
      }

      &:before {
        background-color: transparent !important;
      }

      & > span {
        color: #F94337 !important;
      }
    }

  }

  & .v-tabs-bar {
    height: unset;
  }

  & .v-tabs-bar,
  & .theme--light.v-tabs-items {
    background-color: transparent !important;
  }

  .mdi-arrow-right-bold-box-outline::before {
    position: absolute;
    top: -10px;
    content: '';
    background: url("/local/templates/international/img/fi_chevron-down.svg") no-repeat;
    background-size: contain;
    width: 25px;
    height: 25px;
  }

  .mdi-arrow-left-bold-box-outline::before {
    position: absolute;
    top: -10px;
    content: '';
    background: url("/local/templates/international/img/fi_chevron-down.svg") no-repeat;
    background-size: contain;
    width: 25px;
    height: 25px;
    rotate: 180deg;
  }

  & .v-ripple__container {
    display: none;
  }

  .v-slide-group__next, .v-slide-group__prev {
    min-width: 33px;
  }

  .v-slide-group__wrapper {
    height: 60px;
  }

  .v-sheet.v-card:not(.v-sheet--outlined) {
    box-shadow: none !important;
  }

  & .package-type__content {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 8px;
    border-radius: 40px !important;
    background: #FFFFFF;

    @media (max-width: 768px) {
      grid-template-columns: 1fr;
    }

    & > div {
      height: 460px;

      @media (max-width: 768px) {
        height: max-content;
      }
    }

    & .v-slide-group__content {
      display: block;
      flex: unset;
      width: 100%;
    }

    & .v-slide-group__wrapper {
      height: 100% !important;
    }

    & .theme--light.v-tabs > .v-tabs-bar {
      margin-bottom: 40px;
      height: 100%;
    }

    & .v-tabs {
      position: absolute;
      top: 0;
      height: 100%;
    }

    & .v-tab {
      min-width: unset !important;
      width: 2rem !important;
      height: 2rem !important;
      border-radius: 50% !important;
      padding: 0 !important;

      &--active {
        box-shadow: 0 0 0 0.5rem rgba(251, 66, 55, 0.5) !important;
        border: none;
        mask-image: none;

        &:before {
          display: none;
          background-color: transparent !important;
          width: 32px !important;
          height: 32px !important;
          border-radius: 50% !important;
        }
      }
    }


  }


  &__desc {
    font-family: 'RobotoRegular';
    font-weight: 400;
    font-size: 16px;
    line-height: 26px;
    letter-spacing: 0px;
    vertical-align: middle;
    color: #7D7D7D;
  }

  &__info {
    padding: 30px;
    border-radius: 20px !important;
    border: 1px solid #E8E8E8;
    box-shadow: 0px 4px 12.7px 0px #0000000A;
    display: flex;
    flex-direction: column;
    align-items: start;
    min-height: 460px;

    @media (max-width: 768px) {
      min-height: max-content;
    }

    @media (max-width: 550px) {
      padding: 20px !important;
    }

    & div p {
      font-size: 28px;
      line-height: 36px;
    }

  }

  &__img {
    border-radius: 20px;
    border: 1px solid #E8E8E8;
    width: 100%;
    height: 460px;
    object-fit: contain;

    @media (max-width: 1100px) {
      max-width: unset;
    }
  }

  &__text {
    font-family: 'RobotoRegular';
    font-size: 16px;
    line-height: 26px;
    letter-spacing: 0;
    color: #282828;
  }

  &__btn {
    font-family: 'MuseoSansCyrl-500';
    font-size: 16px;
    line-height: 100%;
    letter-spacing: 0;
    text-align: center;
    color: #FFFFFF !important;
    padding: 16px 32px;
    background: #F94337 !important;
    margin-top: auto;
    border-radius: 48px;

    @media (max-width: 1100px) {
      margin-top: auto;
    }
  }


  &__dots {
    position: relative;
  }

  &__dot {
    position: absolute;
    background: #f94237;
    width: 2rem;
    height: 2rem;
    border-radius: 50%;

    &:before {
      position: absolute;
      content: '';
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      background: #FFFFFF;
      width: 0.8rem;
      height: 0.8rem;;
      border-radius: 50%;
    }

    &:after {
      position: absolute;
      content: '';
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      background: #f94237;
      width: 0.5rem;
      height: 0.5rem;
      border-radius: 50%;
    }
  }
}


</style>